'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (usernameList) {
  var match = usernameList.match(VALID_LIST_RE); // Must have matched and had nothing before or after

  return !!(match && match[1] == '' && match[4]);
};

var _regexSupplant = require('./lib/regexSupplant');

var _regexSupplant2 = _interopRequireDefault(_regexSupplant);

var _validMentionOrList = require('./regexp/validMentionOrList');

var _validMentionOrList2 = _interopRequireDefault(_validMentionOrList);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0


var VALID_LIST_RE = (0, _regexSupplant2.default)(/^#{validMentionOrList}$/, {
  validMentionOrList: _validMentionOrList2.default
});
module.exports = exports['default'];